import React, { useEffect, useRef } from "react";
import { IMessage, useChatState } from "../../state/ChatState";

export const AIMessage = ({ message }: { message: IMessage }) => {
	return (
		<div className="flex justify-start items-start space-x-3">
			<div
				className="w-8 h-8 bg-gradient-to-r from-blue-500 to-blue-600 rounded-full flex items-center justify-center flex-shrink-0 mt-1 relative"
				style={{
					background:
						"linear-gradient(145deg,rgb(47, 101, 146) 0%, #6589A2 100%) 0% 0% no-repeat padding-box",
					borderRadius: "30px",
					boxShadow: "1px 1px 10px rgba(47, 101, 146, 0.9)",
					opacity: 1,
				}}
			>
				{/* Large circle */}
				<div className="absolute left-1 top-2 w-2.5 h-2.5 bg-white rounded-full"></div>
				{/* Medium circle */}
				<div className="absolute left-4 top-3 w-1.5 h-1.5 bg-white rounded-full"></div>
				{/* Small circle 1 */}
				<div className="absolute left-4 top-5 w-2 h-2 bg-white rounded-full"></div>
				{/* Small circle 2 */}
				<div className="absolute left-6 top-2.5 w-1 h-1 bg-white rounded-full"></div>
			</div>
			<div
				className="bg-gradient-to-r from-blue-600 to-blue-700 text-white rounded-3xl rounded-tl-md 
                               px-6 py-4 max-w-[85%] text-sm leading-relaxed"
				style={{
					background:
						"transparent linear-gradient(292deg,rgba(178, 233, 255, 0.49) 0%, rgba(109, 190, 238, 0.49) 31%, rgba(65, 156, 222, 0.49) 100%) 0% 0% no-repeat padding-box",
				}}
			>
				{message.text}{" "}
			</div>
		</div>
	);
};

export const UserMessage = ({ message }: { message: IMessage }) => {
	return (
		<div className="flex justify-end items-end">
			<div
				className="bg-[#39475e] text-white rounded-2xl rounded-tr-md px-6 py-4 max-w-[85%] 
                               text-sm leading-relaxed"
			>
				{message.text}
			</div>
			<div className="flex items-center justify-center flex-shrink-0  relative w-4 h-4">
				{/* Large circle */}
				<div className="absolute right-2.5 top-[-2px] w-4 h-4  rounded-full bg-[#39475e]"></div>
				{/* Medium circle */}
				<div className="absolute left-1 top-2.5 w-2 h-2 bg-[#39475e] rounded-full"></div>
			</div>
		</div>
	);
};

export const DFXiaomiMessages = () => {
	const chatState = useChatState();
	const messages = chatState.chatMessages;
	const messagesRef = useRef<HTMLDivElement>(null);

	useEffect(() => {
		window.symantoAgentTester.messageChannel.port2.onmessage = (event) => {
			const { Id, Role, IsComplete, Content } = event.data;
			const _msg: IMessage = {
				id: Id,
				conversationId: Id,
				messageAuthor: Role == "2" ? 0 : 1,
				text: Content,
				finalMessage: IsComplete,
				date: new Date().toISOString(),
			};
			chatState.updateMessage(_msg, true);
			messagesRef.current?.scrollTo({
				top: messagesRef.current?.scrollHeight,
				behavior: "smooth",
			});
		};
	}, []);

	return (
		<div
			ref={messagesRef}
			className="overflow-y-auto space-y-4 h-full p-4 pt-6"
		>
			{messages.map((message) =>
				message.messageAuthor === 1 ? (
					<UserMessage key={message.id} message={message} />
				) : (
					<AIMessage key={message.id} message={message} />
				),
			)}
		</div>
	);
};
